/**
 * MuiSvgIcon
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?node-id=572%3A29384&mode=dev)
 */
const MuiSvgIcon = {
  styleOverrides: {
    root: () => ({
      '&:not(.MuiSvgIcon-colorPrimary)': {
        // TODO danielmana override the default color without affecting icons inside primary buttons
        // color: theme.palette.grey[600],
      }
    })
  }
};
export default MuiSvgIcon;